<template>
	<div v-if="rating?.stars" class="location-trustpilot-reviews" :class="`location-trustpilot-reviews--${variant}`">
		<template v-if="variant === 'pill'">
			<GlobalIcon name="trustpilot-icon" :width="16" />
			<div class="location-trustpilot-reviews__divider"></div>
			<div class="location-trustpilot-reviews__container">
				<div class="location-trustpilot-reviews__stars">
					<GlobalRating :rating="rating.stars" readonly colorFilled="#00B67A" colorEmpty="#00B67A" />
				</div>
				<p class="location-trustpilot-reviews__text">
					{{ formatRating(rating.ratings) }},
					<a :href="rating.url" target="_blank" class="location-trustpilot-reviews__link">
						{{ rating.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
					</a>
				</p>
			</div>
		</template>
		<template v-else>
			<div class="location-trustpilot-reviews__bar-logo">
				<GlobalIcon name="trustpilot-icon" :height="16" />
			</div>
			<p data-aos="fade-up" class="location-trustpilot-reviews__bar-text">
				{{ $t('modules.home_page_module.testimonials.assessment') }} {{ formatRating(rating.ratings) }}
				{{ $t('modules.home_page_module.testimonials.of') }}
				<a :href="rating.url" target="_blank" class="location-trustpilot-reviews__bar-link">
					{{ rating.ratingsCount }} {{ $t('modules.home_page_module.testimonials.reviews') }}
				</a>
				TRUSTPILOT
			</p>
		</template>
	</div>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		variant?: 'pill' | 'bar'
	}>(),
	{ variant: 'pill' },
)

const trustpilotRatingsStore = useTrustpilotRatingsStore()

const rating = computed(() => trustpilotRatingsStore.getTrustpilotRating)

onServerPrefetch(() => trustpilotRatingsStore.fetchTrustpilotRating())
onMounted(() => {
	if (!rating.value) trustpilotRatingsStore.fetchTrustpilotRating()
})
</script>

<style lang="scss" scoped src="./TrustpilotReviews.scss"></style>
